import { render, staticRenderFns } from "./ClonePromotionModal.vue?vue&type=template&id=0735272c&"
import script from "./ClonePromotionModal.vue?vue&type=script&lang=ts&"
export * from "./ClonePromotionModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports